<template>
  <header class="header-wrap">
    <BigCarousel :list="bannerList" />
    <NavContent />
  </header>
</template>

<script>
import BigCarousel from './BigCarousel';
import NavContent from './NavContent';
import { getLogo } from '@/api';
export default {
  name: 'TopContent',
  components: {
    NavContent,
    BigCarousel,
  },
  data() {
    return {
      bannerList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { code, result } = await getLogo({ type: 'banner1' });
      this.bannerList = result;
    },
  },
};
</script>

<style lang="scss" scope></style>
